import React from "react";

const HomeCard = ({ cardName, cardValue, link, linkText, icon }) => {
  return (
    <div className="mono_dash_card_wrapper">
      <div className="mono_content">
        <div className="mono_widget_icon">{icon}</div>
        <div className="mono_widget_info">
          <p>{cardName}</p>
          <h2>{cardValue}</h2>
        </div>
      </div>
    </div>
  );
};

export default HomeCard;
